( function ( _s ) {
	_s( window ).on( 'fr:update-url-params', e => {
		const urlParams = e.detail.urlParams;
		const currPath = window.location.href.split( '?' )[ 0 ];
		const newUrl = currPath + ( urlParams.length ? `?${ urlParams }` : '' );
		window.history.replaceState( {}, '', newUrl );
	} );
} )( window._s );
